import { render } from "./SearchOptions.vue?vue&type=template&id=aed2253a&scoped=true&ts=true&lang=pug"
import script from "./SearchOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchOptions.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./SearchOptions.vue?vue&type=style&index=0&id=aed2253a&lang=scss&module=true&scoped=true"
cssModules["$style"] = style0

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-aed2253a"]])

export default __exports__